import React, { useEffect } from 'react';
import { useLocation} from 'react-router-dom';
import Cookies from 'universal-cookie';

import './Login.css'
import './Spinner.css'

function LogoutPage() {
    const location = useLocation();
    
    const queryParams = new URLSearchParams(location.search);
    const dynamicURLParam = queryParams.get('dynamicURL');

    // Se quiere habilitar la url /logoput?token=xxx&status=xxx&dynamicURL=xxx para que elimine todas las cokies y redirija a dynamicURL
    // y redirija a dynamicURL de forma directa. Si dynamicURL no viene, se redirige a /
    useEffect(() => {

        // Eliminar las cookies de 'universal-cookie'
        const cookies = new Cookies();
        const allCookies = cookies.getAll();
        for (let cookieName in allCookies) {
            if (cookieName.startsWith('SSO')) {
                
                cookies.remove(cookieName, { path: '/' });

                // Si la cookie tiene un dominio específico, también intentamos eliminarla con ese dominio
                const domain = window.location.hostname;
                if (domain) {
                    cookies.remove(cookieName, { path: '/', domain: domain });
                }

                // Si la cookie tiene un dominio específico (sin subdominio), también intentamos eliminarla con ese dominio
                const domainWithoutSubdomain = domain.split('.').slice(-2).join('.');
                if (domainWithoutSubdomain) {
                    cookies.remove(cookieName, { path: '/', domain: domainWithoutSubdomain });
                }

                // Intentamos eliminar la cookie sin especificar el path (por si acaso)
                cookies.remove(cookieName);
            }
        }
        
        // Eliminamos el localStorage
        localStorage.clear();
        sessionStorage.clear();

        if (dynamicURLParam) {
            window.location.href = dynamicURLParam;
        } else {
            window.location.href = '/';
        }
    }, []);

    return <></>;

    
}

export default LogoutPage;